import { render, staticRenderFns } from "./DeleteLessonCategoryDialog.vue?vue&type=template&id=5abd6bf6"
import script from "./DeleteLessonCategoryDialog.vue?vue&type=script&lang=js"
export * from "./DeleteLessonCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports